<template>
  <v-container fluid>
    <div v-if="userLoaded && user.can('view_rootentity')">
      <h2>{{ $t('api_usage') }}</h2>
      <api-access-log-statistics/>
    </div>
    <v-alert v-else-if="userLoaded" type="info" outlined class="mt-4">
      {{ $t('root_only_page') }}
    </v-alert>
  </v-container>
</template>
<script>

import ApiAccessLogStatistics from '@/components/api-access-log/ApiAccessLogStatistics'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

/**
 * The API usage statistics page.
 *
 * Root only, gated on the same permission as the request browser page and for
 * the same reason: api_access_log spans every customer, so a customer admin must
 * not be shown these figures. The API's own check is the authoritative one
 * (ApiAccessLogStatisticsController::checkAccess()); this guard only decides what
 * to render, and keeps a non-root visitor from firing four requests the API
 * would answer with a 404.
 */
export default {
  name: 'ApiAccessLogStatisticsIndex',
  components: {
    ApiAccessLogStatistics
  },
  mixins: [
    BrowserUtilitiesMixin,
    CurrentUserMixin
  ],
  mounted () {
    this.updateBrowserTitle(this.$t('api_usage'))
  }
}
</script>
